import Compressor from 'compressorjs';

// compress image
export const compressImage = (file, options, callback) => {
    if (!file) return;

    // default 60% compression
    if (!options) options = { quality: 0.6, maxWidth: 1000, convertSize: 5000000 };

    new Compressor(file, {
        ...options,
        success(result) {
            _base64(result, (dataURL) => {
                callback(file.name, dataURL);
            })
        },
        error(err) {
            console.log(err.message);
            callback(null);
        },
    });
}

// convert image to base 64
function _base64(file, callback) {
    var reader = new FileReader();
    reader.onloadend = function () {
        callback(reader.result);
    }
    reader.readAsDataURL(file);
}